import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromBjelkelag } from "@/components/calculators/lineMappers";
import { bjelkelagCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/bjelkelag")({
  component: BjelkelagPage,
});

function BjelkelagPage() {
  const [bredde, setBredde] = useState<number | "">("");
  const [lengde, setLengde] = useState<number | "">("");
  const [cc, setCc] = useState<number | "">(600);

  const r = useMemo(() => {
    if (bredde === "" || lengde === "" || cc === "") return null;
    return bjelkelagCalc({
      bredde_m: Number(bredde),
      lengde_m: Number(lengde),
      cc_mm: Number(cc),
    });
  }, [bredde, lengde, cc]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Bjelkelag" subtitle="Beregn antall bjelker for gulv eller etasjeskille." />
      <CalcShell
        title="Inndata"
        advisory="Dimensjon (48x198 / 48x223 osv.) må velges basert på spennvidde og last – bruk konstruktør­tabell eller prosjekterende."
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Antall bjelker",  value: `${fmt(r.antall_bjelker, 0)} stk`, strong: true },
              { label: "Lengde pr bjelke", value: `${fmt(r.bjelke_lengde_m, 2)} m` },
              { label: "Total løpemeter",  value: `${fmt(r.total_lm, 1)} m` },
            ]}
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Bjelkelag`} lines={linesFromBjelkelag(r)} defaultLaborHours={Math.max(0, Math.round((r.antall_bjelker * 0.4) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn mål og c/c.</div>}
      >
        <Field label="Bredde (på tvers av bjelker)" unit="m"><NumberInput value={bredde} onChange={setBredde} /></Field>
        <Field label="Lengde / spennvidde" unit="m"><NumberInput value={lengde} onChange={setLengde} /></Field>
        <Field label="c/c bjelker" unit="mm"><NumberInput value={cc} onChange={setCc} /></Field>
      </CalcShell>
    </>
  );
}
